// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildMinified,
  BuildMinifiedFromJSON,
  BuildMinifiedToJSON,
  ReleaseReadinessTestPlanRun,
  ReleaseReadinessTestPlanRunFromJSON,
  ReleaseReadinessTestPlanRunToJSON,
  ResultSummary,
  ResultSummaryFromJSON,
  ResultSummaryToJSON,
} from "./";

/**
 * Per-test-plan readiness summary within a release, showing the latest run's results.
 * @export
 * @interface ReleaseReadinessTestPlan
 */
export interface ReleaseReadinessTestPlan {
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessTestPlan
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof ReleaseReadinessTestPlan
   */
  title: string;
  /**
   * 0 = Draft; 1 = Ready to execute; 2 = Finish; 3 = Finished (with failures)
   * @type {number}
   * @memberof ReleaseReadinessTestPlan
   */
  status: ReleaseReadinessTestPlanStatusEnum;
  /**
   *
   * @type {BuildMinified}
   * @memberof ReleaseReadinessTestPlan
   */
  build?: BuildMinified;
  /**
   *
   * @type {ReleaseReadinessTestPlanRun}
   * @memberof ReleaseReadinessTestPlan
   */
  latestRun: ReleaseReadinessTestPlanRun;
  /**
   *
   * @type {ResultSummary}
   * @memberof ReleaseReadinessTestPlan
   */
  results: ResultSummary;
}

export function ReleaseReadinessTestPlanFromJSON(
  json: any
): ReleaseReadinessTestPlan {
  return {
    id: json["id"],
    title: json["title"],
    status: json["status"],
    build: !exists(json, "build")
      ? undefined
      : BuildMinifiedFromJSON(json["build"]),
    latestRun: ReleaseReadinessTestPlanRunFromJSON(json["latest_run"]),
    results: ResultSummaryFromJSON(json["results"]),
  };
}

export function ReleaseReadinessTestPlanToJSON(
  value?: ReleaseReadinessTestPlan
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    title: value.title,
    status: value.status,
    build: BuildMinifiedToJSON(value.build),
    latest_run: ReleaseReadinessTestPlanRunToJSON(value.latestRun),
    results: ResultSummaryToJSON(value.results),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ReleaseReadinessTestPlanStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
}
